import {
    Grid,
    Typography, withStyles
} from '@material-ui/core';
import React from 'react';
import AppUtils from '../../../control/apputlis';
import ChatUtils from '../../../control/ChatUtils';
import FIMUtils from '../../../im/FIMUtils';
import AppData from '../../../model/AppData';
import MessageType from '../../../net/IMMessageType';
import './animateText/index.css';

const SYS_TIPS = '系统提示：本直播努力营造积极健康的直播环境，对直播内容进行24小时巡查， 任何传播违法、违规、诈骗、低俗不良、血腥暴力封建迷信等信息的行为一经发 现，将对违规者账号予以封号处理。';

const roomAdmin = require('../../../images/vip/room_admin.png')
const roomZb = require('../../../images/vip/room_zb.png')

const vipLevelMinImg = [
    require('../../../images/vip/vip_room_min_0.png'),
    require('../../../images/vip/vip_room_min_1.png'),
    require('../../../images/vip/vip_room_min_2.png'),
    require('../../../images/vip/vip_room_min_3.png'),
    require('../../../images/vip/vip_room_min_4.png'),
    require('../../../images/vip/vip_room_min_5.png'),

]



class MovieChatItem extends React.Component {



    getImageInfo(msg) {
        try {
            let info = JSON.parse(msg.content);
            return FIMUtils.getFixImageSize(info);
        } catch (error) {
            return { url: '', width: 0, height: 0 }
        }
    }

    renderSys = () => {
        const { classes, data } = this.props;
        return (
            <Grid container direction='row' justifycontent='center' style={{ width: '100vw', paddingTop: 4, paddingBottom: 4 }}  >
                <Typography className={classes.sysmsg}> {data.payload.text}</Typography>
            </Grid>
        );
    }

    renderImage = (data) => {
        const { classes } = this.props;
        let obj = this.getImageInfo(data);
        return (
            <Grid container direction='row' justifycontent='center' style={{ flex: 1, paddingTop: 4, paddingBottom: 4, paddingLeft: 8, paddingRight: 8 }}  >
                <img src={obj.url} height={obj.height} width={obj.width} className={classes.img}></img>
            </Grid>
        );
    }



    testLog = (data) => {
        console.log(data);
        let urls = AppUtils.getUrlFromContent(data.content);
        if (urls && urls.length > 0) {
            AppUtils.openUrl(urls[0]);
        }
    }

    rendTips = () => {
        const { classes } = this.props;
        if (AppData.ServerConfig && AppData.ServerConfig.chat_show_url && AppData.ServerConfig.chat_show_url.length > 0) {
            return (
                <div className={classes.roomTips}>
                    <span style={{ fontSize: 10 }}>{SYS_TIPS + '防丢失请记住备用域名'}</span>
                    <a target="_blank" href={AppData.ServerConfig.chat_show_url}>{AppData.ServerConfig.chat_show_url}</a>
                    <span>或者下载APP</span>
                </div>
            )
        } else {
            return (<></>)
        }
    }

    onClickAd = (url) => {
        AppUtils.openUrl(url);
        AppUtils.YMPush("MAIN", "点击聊天广告");
    }

    renderAd = (data) => {
        const { classes } = this.props;
        return (
            <Grid container alignItems='center' direction='row' className={classes.adBack} onClick={() => this.onClickAd(data.url)}>
                <img src={data.img} className={classes.adImg}></img>
                <Grid container direction='column' className={classes.adInfo}>
                    <Typography align='left' noWrap className={classes.adTitle}>{data.title}</Typography>
                    <span className={classes.adContent}>{data.content}</span>
                </Grid>
            </Grid>
        )
    }

    render() {
        const { classes, data } = this.props;

        //isadmin  0不是，1管理员，2主播
        let textColor = '#6197E8'   //这是昵称的颜色
        let conterColor = '#0D0D0D'   //这是文本的颜色

        let paddingleft = 40;

        if (data.viplevel == 3) {
            textColor = '#FB780A'
            conterColor = '#FB780A'
        }
        if (data.viplevel == 0) {
        }
        if (data.viplevel == 4) {
            textColor = '#E832EF'
            conterColor = '#E832EF'
        }
        if (data.viplevel == 5) {
            textColor = '#FF0006'
            conterColor = '#FF0006'
        }
        if (data.isadmin == 1) {
            textColor = '#3859E2'
            conterColor = '#3859E2'
        }
        if (data.isadmin == 2) {
            textColor = '#6197E8'
            conterColor = '#0D0D0D'
        }
        if (data.isSys) {
            return this.renderSys();
        }
        let content;
        if (data.content && data.content.length > 0) {
            content = AppData.keywordShield(data.content);
        } else {
            content = data.content;
        }

        return (
            <Grid container direction='row' style={{ width: '96vw', paddingTop: 2, paddingBottom: 2 }}>
                {/* <Typography className={classes.nick}> {data.nickname + ':'}</Typography> */}
                {
                    FIMUtils.isMessageText(data.msgtype) && <Grid className={classes.back}>
                        <Grid className={classes.msg} style={{ paddingLeft: paddingleft }}>
                            {data.viplevel !== 0 && data.isadmin == 0 && <img src={vipLevelMinImg[data.viplevel]} style={{ width: 26, height: 26, position: 'absolute', left: 6, top: 0 }} />}
                            {data.viplevel == 0 && data.isadmin == 0 && <img src={vipLevelMinImg[data.viplevel]} style={{ width: 26, height: 26, position: 'absolute', left: 6, top: 0 }} />}
                            {data.isadmin == 1 && <img src={roomAdmin} style={{ width: 26, height: 26, position: 'absolute', left: 6, top: 0 }} />}
                            {data.isadmin == 2 && <img src={roomZb} style={{ width: 26, height: 26, position: 'absolute', left: 6, top: 0 }} />}
                            <span className={classes.nick} style={{ color: textColor }}>{data.nickname + ':'}</span>
                            {
                                ChatUtils.createHtml(content, conterColor)
                            }

                        </Grid>
                    </Grid>
                }
                {
                    FIMUtils.isMessageImage(data.msgtype) && this.renderImage(data)
                }
                {data.msgtype == MessageType.AD && this.renderAd(data)}
                {
                    data.msgtype == 10010 && this.rendTips()
                }
                {/* {
                    FIMUtils.isComing(data.msgtype) && <Grid className={classes.back}>
                        <Grid className={classes.conming}  >
                            <img src={ICON_COMING} className={classes.welcomeimg} />
                            <span className={classes.welcome}>欢迎</span>
                            <span style={{ color: '#FFF', marginRight: 5 }}>{data.content}</span>

                            <span style={{ color: '#FFF',marginRight: 10 }}>加入聊天室</span>

                        </Grid>
                    </Grid>
                } */}
            </Grid>
        );
    }
}

export default withStyles((theme) => ({
    roomTips: {
        color: '#878787',
        backgroundColor: '#EAEAEA',
        marginLeft: 10,
        padding: 10,
        fontSize: 10,
        borderRadius: 10,
        lineHeight: 1.4,
        marginTop: 8
    },
    adBack: {
        backgroundColor: '#FFFFFF',
        marginLeft: 10,
        padding: 2,
        borderRadius: 10,
        marginTop: 8
    },
    nick: {
        // fontSize: 14,
        // color: '#F28C1F',
        // marginLeft: 8,
        // marginTop: 8,
        marginRight: 10,
    },
    welcomeimg: {
        width: 18,
        height: 18,
        position: 'absolute',
        top: 0,
        left: 15,
        bottom: 0,
        margin: 'auto'//使其垂直居中
    },
    conming: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        color: '#FFF',
        fontSize: 12,
        backgroundColor: '#B080FF',
        borderRadius: 30,
        marginLeft: 8,
        marginRight: 8,
        maxWidth: '75vw',
        display: 'inline-block',
        lineHeight: 2.4,
        position: 'relative',

    },
    welcome: {
        marginRight: 5,
        marginLeft: 30
    },

    sysmsg: {
        fontSize: 11,
        color: '#52C736',
        marginTop: 4,
    },
    img: {
        maxWidth: '100%',
        height: 'auto',
        borderRadius: 4,
    },
    back: {
        backgroundColor: 'tranparent',
        flex: 1,
    },
    msg: {
        // paddingTop: 4,
        paddingRight: 8,
        // paddingBottom: 4,
        color: '#0D0D0D',
        fontSize: 11,
        backgroundColor: '#FFF',
        borderRadius: 8,
        marginLeft: 8,
        marginRight: 8,
        maxWidth: '75vw',
        display: 'inline-block',
        position: 'relative'
    },
    adImg: {
        width: 70,
        height: 70,
        marginLeft: 2,
        borderRadius: 8
    },
    adTitle: {
        fontSize: 13,
        color: '#0D0D0D',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        width: '100%'
    },
    adContent: {
        marginTop: 4,
        fontSize: 10,
        color: '#878787',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitLineClamp: 2,
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        width: '100%'
    },
    adInfo: {
        marginLeft: 12,
        flex: 1,
        width: 'calc(100vw - 150px)',
    }
}))(MovieChatItem);